import React, { useState } from 'react';

import {
  Modal,
  Spinner,
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import {
  ArrowRightIcon,
  LockClosedIcon,
  UserIcon,
} from '@heroicons/react/24/outline';
import { InformationCircleIcon } from '@heroicons/react/24/solid';

import AppFooter from '../../../components/shared/footer';
import { apiGetPMA } from '../../../core/api';
import {
  signIn,
  verifyUserCode,
} from '../../../core/plugins/Entry';
import AuthLayout from '../../layouts/AuthLayout';
function PMLanding() {
  const navigate = useNavigate()
  const [loading, setLoading] = React.useState(false)

  const [payload, setPayload] = React.useState({
    username: "",
    password: "",
    type: "AA"
  })

  const onChange = (e) => {
    setPayload((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value
    }))
  }

  const [tempUser, setTempUser] = useState(null)
  const [showVerificationModal, setShowVerificationModal] = useState(false)
  const [verificationCode, setVerificationCode] = useState('')

  const handleVerificationCodeChange = (e) => {
    setVerificationCode(e.target.value)
  }

  const submitVerificationCode = async () => {
    try {
      const verified = await verifyUserCode(tempUser, verificationCode)
      if (verified) {
        apiGetPMA(tempUser.UUID).then((response) => {
          if (response && response.PMAID) {
            toast.success(`Welcome`)
            navigate("/aa/issues")
          } else {
            toast.warn("User is not a Agent Administrator")
          }
        })
        setShowVerificationModal(false)
      } else {
        toast.error("Invalid verification code")
      }
    } catch (error) {
      toast.error("Error verifying code")
    }
  }

  const login = (e) => {
    e.preventDefault()
    setLoading(true)
    setTimeout(() => {
      signIn(payload).then((response) => {
        setTempUser(response.tempUser)
        if (response.message === "User is not confirmed.") {
          openConfirmUserModal()
          setLoading(false)
        }
        if (response.requireVerification && response.user.username) {
          setTempUser(response.tempUser)
          setShowVerificationModal(true)
          setLoading(false)
        }
      })
      .finally(() => {
        setLoading(false)
      })
    }, 1000)
  }
  const [confirm, setConformPayload] = React.useState({
    email: "",
    code: ""
  })

  const onConfirmPayloadChange = (e) => {
    setConformPayload((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value
    }))
  }

  const [showConfirmUser, setShowConfirmUser] = React.useState(false)

  const openConfirmUserModal = () => {
    setShowConfirmUser(true)
  }

  const handleConfirmUserModalClose = () => {
    setShowConfirmUser(false)
  }

  const submitConfirmUser = () => {
    handleConfirmUserModalClose()
  }
  return (
    <>
      <Modal
        show={showConfirmUser}
        onHide={handleConfirmUserModalClose}
        backdrop="static"
        className="confirm-modal"
      >
        <Modal.Body>
          <div className="spacer-lg"></div>
          <div className="top-icon">
            <InformationCircleIcon />
          </div>
          <div className="spacer-sm"></div>
          <h4>User not confirmed.</h4>
          <p>
            Verify your email address <br />
            <small>
              Please click the verification link sent to your email address
            </small>
          </p>
          <div className="input-element">
            <button
              onClick={submitConfirmUser}
              className="primary-button primary-button-small"
            >
              <div className="button-text">Close</div>
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={showVerificationModal} onHide={() => setShowVerificationModal(false)} backdrop="static" className="verification-modal">
        <Modal.Header closeButton>
          <Modal.Title>Verification Code</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Please enter the verification code sent to your email.</p>
          <div className="verification-input">
            <input
              type="text"
              value={verificationCode}
              onChange={handleVerificationCodeChange}
              placeholder="Enter code here"
              className="form-control"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={submitVerificationCode} className="btn btn-primary">
            Verify
          </button>
        </Modal.Footer>
      </Modal>
      <AuthLayout>
        <div className="container login-form-page ">
          <div className="d-flex flex-column justify-content-center">
            <div className="row justify-content-center">
              <div className="col-md-8 text-center">
                <div className="spacer-lg"></div>
                <div className="spacer-lg"></div>
                <h2 className="text-center">Login as an Agency admin</h2>
                <h4>Please sign in to continue</h4>
                <div className="spacer-lg"></div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-4">
                <form onSubmit={login}>
                  <div className="input-element">
                    {/* <label>Username</label> */}
                    <div className="input-wrapper">
                      <div className="left-icon">
                        <UserIcon />
                      </div>
                      <input
                        autoFocus
                        value={payload.username}
                        name="username"
                        type="email"
                        placeholder="Email"
                        required
                        onChange={onChange}
                      ></input>
                    </div>
                  </div>

                  <div className="input-element">
                    {/* <label>Password</label> */}
                    <div className="input-wrapper">
                      <div className="left-icon">
                        <LockClosedIcon />
                      </div>
                      <input
                        value={payload.password}
                        name="password"
                        type="password"
                        placeholder="Password"
                        required
                        onChange={onChange}
                      ></input>
                    </div>
                  </div>

                  <div className="input-element text-center">
                    <button
                      disabled={loading}
                      type="submit"
                      className="primary-button"
                    >
                      <div className="button-text">
                        {loading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          "Login"
                        )}
                      </div>
                      <div className="right-icon">
                        <ArrowRightIcon />
                      </div>
                    </button>
                  </div>
                </form>
              <AppFooter/>
              </div>
            </div>
          </div>
        </div>
      </AuthLayout>
    </>
  )
}

export default PMLanding
